import React from 'react'
import PropTypes from 'prop-types'
import { Paper, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'

export const panelStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(2),
    position: 'relative',
    marginTop: '2rem'
  },
  title: {
    position: 'absolute',
    height: '1rem',
    lineHeight: '1rem',
    top: '-1.5rem',
    left: 0
  }
}))

const Panel = ({ title, children, ...props }) => {
  const classes = panelStyles()
  return (
    <Paper classes={{ root: classes.root }} {...props}>
      <Typography
        variant="overline"
        className={classes.title}>
        {title}
      </Typography>
      <div className={classes.content}>{children}</div>
    </Paper>
  )
}

Panel.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string
}

export default Panel
